import { render } from "./AudioPage.vue?vue&type=template&id=b0a26f0a"
import script from "./AudioPage.vue?vue&type=script&lang=js"
export * from "./AudioPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__